import { useEffect } from "react";

interface MetaOptions {
  title: string;
  description?: string;
  keywords?: string;
}

function upsertMeta(name: string, content: string) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export function useDocumentMeta({ title, description, keywords }: MetaOptions) {
  useEffect(() => {
    document.title = title;
    if (description) upsertMeta("description", description);
    if (keywords) upsertMeta("keywords", keywords);
  }, [title, description, keywords]);
}